'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeAddress = exports.getAddressDetails = exports.searchAddress = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var searchAddress = exports.searchAddress = function searchAddress() {
  var postcode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return _client.jgClient.get('/address/paf-tuples-by-postcode/' + postcode).then(function (_ref) {
    var data = _ref.data;

    if (data.IsSuccess) {
      return data.IsMultiple ? data.MultipleAddresses : [data.OneAddress];
    }

    return [];
  });
};

var getAddressDetails = exports.getAddressDetails = function getAddressDetails() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return _client.jgClient.get('/address/paf-by-id/' + id).then(function (_ref2) {
    var data = _ref2.data;
    return data.OneAddress;
  });
};

var deserializeAddress = exports.deserializeAddress = function deserializeAddress(address) {
  return {
    streetAddress: address.AddressLine1,
    extendedAddress: address.AddressLine2,
    locality: address.Town,
    region: address.County,
    postCode: address.Postcode
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/address/justgiving/index.js
// module id = 1399
// module chunks = 0